import styled, { css } from 'styled-components';
import { media, remCalc, layout } from '@prisjakt/ui-base';

import ProductRowComponent from 'src/components/product-row';

const relatedProductsTitleFontSize = remCalc(15);
const boxShadowStyle = '0px 6px 10px 0px rgba(0, 0, 0, 0.2)';

const relatedProductsOverlayStyles = css`
  position: absolute;
  z-index: 4;
  box-shadow: ${boxShadowStyle};
`;

export const RelatedProductsTitle = styled.h5`
  font-size: ${relatedProductsTitleFontSize};
  margin-top: ${layout.measurements.spacing050};
  margin-bottom: 0;
`;

export const RelatedProductsSubTitle = styled.p`
  color: ${p => p.theme.text.quaternary};
`;

type RelatedProductsProps = {
  relatedProductsAsOverlay: boolean;
};

export const RelatedProducts = styled.div<RelatedProductsProps>(
  props => css`
    background: ${props.theme.colors.base0};
    border-radius: 4px;
    width: 100%;

    ${props.relatedProductsAsOverlay &&
      css`
        ${relatedProductsOverlayStyles};
        top: 47px;

        ${RelatedProductsTitle}, ${RelatedProductsSubTitle} {
          padding: 0 ${layout.measurements.spacing100};
        }

        ${media.smallOnly`
          top: 37px;
        `}
      `}
  `
);

type ProductRowProps = {
  showNewComparePageLayout: boolean;
};

export const ProductRow = styled(ProductRowComponent)<ProductRowProps>(
  props => css`
    min-height: auto;

    ${props.showNewComparePageLayout &&
      css`
        ${media.mediumDown`
          padding: 0 ${layout.measurements.spacing100};
        `}
      `}
  `
);
